(() => {
  const headingSelector = 'h1, h2, h3, h4, h5, h6';
  const contentSelector = `${headingSelector}, p, ul, ol, table, blockquote`;

  const cleanClone = (node) => {
    const clone = node.cloneNode(true);
    clone.removeAttribute?.('id');
    clone.querySelectorAll?.('[id]').forEach((element) => element.removeAttribute('id'));
    clone.querySelectorAll?.('meta, script, style').forEach((element) => element.remove());
    return clone;
  };

  const buildProductInformation = (root) => {
    if (root.dataset.pdpInformationReady === 'true') return;

    const fallback = root.querySelector('[data-pdp-information-fallback]');
    const source = root.querySelector('[data-pdp-information-source]');
    const target = root.querySelector('[data-pdp-information-target]');
    if (!fallback || !source || !target) return;

    const fallbackHeading = fallback.querySelector('.pdp-information__title')?.textContent.trim() || 'Product Details';
    const sections = [];
    let currentSection = null;

    source.querySelectorAll(contentSelector).forEach((node) => {
      if (node.matches(headingSelector)) {
        const title = node.textContent.trim();
        if (!title) return;
        currentSection = { title, nodes: [] };
        sections.push(currentSection);
        return;
      }

      const containingGroup = node.closest('ul, ol, table, blockquote');
      if (node.closest('li') || (containingGroup && containingGroup !== node)) return;

      if (!currentSection) {
        currentSection = { title: fallbackHeading, nodes: [] };
        sections.push(currentSection);
      }
      currentSection.nodes.push(node);
    });

    if (!sections.length) return;

    const caret = fallback.querySelector('summary .icon-caret');
    const fragment = document.createDocumentFragment();

    sections.forEach((section, index) => {
      const details = document.createElement('details');
      details.className = 'pdp-information__row';
      details.open = index === 0 && root.dataset.openFirst === 'true';

      const summary = document.createElement('summary');
      const title = document.createElement('span');
      title.className = 'pdp-information__title';
      title.textContent = section.title;
      summary.appendChild(title);
      if (caret) summary.appendChild(caret.cloneNode(true));

      const content = document.createElement('div');
      content.className = 'pdp-information__content rte';
      section.nodes.forEach((node) => content.appendChild(cleanClone(node)));

      details.append(summary, content);
      fragment.appendChild(details);
    });

    target.replaceChildren(fragment);
    target.hidden = false;
    fallback.hidden = true;
    root.dataset.pdpInformationReady = 'true';
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-pdp-information]').forEach(buildProductInformation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
